<template>
  <div class="purchase_index">
    <div class="purchase_index_nav">
      <img
        class="back"
        src="../../../assets/accountAgent/my/reback.png"
        @click="goBack"
      />
      <div
        class="account_msg"
        @click="switchAccount"
        v-if="shopInfo.is_supplier == 0"
      >
        <img src="../../../assets/purchaseSupplier/withdraw/switch_icon.png" />
        切换账户
        <!-- <span class="num">99+</span> -->
      </div>
    </div>
    <van-row class="box">
      <van-col span="24" class="name"
        >{{ shopInfo.shop_name
        }}<span v-if="shopInfo.is_supplier == 0"
          ><img
            src="../../../assets/purchaseSupplier/withdraw/customer_staff.png"
          />客服员工</span
        ></van-col
      >
      <van-col span="24" class="manage">
        <img
          class="mask"
          src="../../../assets/purchaseSupplier/common/bg_mark.png"
          alt=""
        />
        <div class="ship-box">
          <div class="goods ship" @click="seeOrder">
            <p class="number">{{ orderInfo.wait_deliver || 0 }}</p>
            <p class="type">待发货</p>
            <img
              src="../../../assets/purchaseSupplier/common/toShip.png"
              alt=""
            />
          </div>
          <div class="goods receive" @click="seeAfterOrder">
            <p class="number">{{ orderInfo.wait_receipts_after || 0 }}</p>
            <p class="type">待收货(售后)</p>
            <img
              src="../../../assets/purchaseSupplier/common/receiveGoods.png"
              alt=""
            />
          </div>
        </div>
        <div
          class="operationItem"
          @click="stockManage"
          v-if="shopInfo.is_supplier == 1"
        >
          <img src="../../../assets/purchaseSupplier/common/stock.png" alt="" />
          库存管理
          <van-icon name="arrow" />
        </div>
        <div
          class="operationItem"
          @click="toWithdraw"
          v-if="shopInfo.is_supplier == 1"
        >
          <img
            src="../../../assets/purchaseSupplier/common/toWithdraw.png"
            alt=""
          />
          提现管理
          <van-icon name="arrow" />
        </div>
        <div
          class="operationItem"
          @click="seeContract"
          v-if="shopInfo.is_supplier == 1"
        >
          <img
            src="../../../assets/purchaseSupplier/common/contract.png"
            alt=""
          />
          查看合同
          <van-icon name="arrow" />
        </div>
        <div class="operationItem" @click="seeMSG">
          <img
            src="../../../assets/purchaseSupplier/common/contact.png"
            alt=""
          />
          客服聊天
          <van-icon v-if="msgNum == 0" name="arrow" />
          <span class="msg" v-else>
            <span class="num">{{ msgNum }}</span>
          </span>
        </div>
        <div
          class="operationItem"
          @click="openMiniProgram"
          v-if="shopInfo.is_supplier == 1"
        >
          <img
            src="../../../assets/purchaseSupplier/withdraw/add_staff.png"
            alt=""
          />
          添加员工
          <van-icon name="arrow" />
        </div>
      </van-col>
    </van-row>
    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
    <van-dialog v-model="show" 
    title="账户已封禁" 
    class="banned-box" 
    confirmButtonText="我知道了" 
    cancelButtonText="切换账户" 
    :showCancelButton="shopInfo.is_supplier != 1" 
    @confirm="knowBack" 
    @cancel="switchAccount"
    confirmButtonColor="#F9591B" 
    theme="round"
    >
      <div class="banned-poup">
        封禁原因：{{reason}}
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pending: null,
      shopInfo: {},
      orderInfo: {},
      loading: true,
      showPopup: true,
      msgNum: 0,
      currentMemberId: "",
      show:false,
      reason:""
    };
  },
  created() {
    // this.msgNum = this.$route.query.msgNum || 0;
    if (this.$route.query.token) {
      let token = this.$route.query.token.replace(/@$/, "");
      this.$api.setToken(token);
    }
    if (sessionStorage.getItem("bindStoreId")) {
      this.currentMemberId = sessionStorage.getItem("bindStoreId");
      this.getShopInfo();
    } else {
      this.getIdentityInfo();
    }
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    async getInfo() {
      await this.$api.post("member-relation/member/three/year/supplier/detail", {
          id: this.shopInfo.id,
      }).then((res) => {
        if(res&&res.status == 4){
          this.reason = res.reason;
          this.show = true;
        }
      })
    },
    knowBack(){
      this.goBack();
      this.show = false;
    },
    async getIdentityInfo() {
      // let bindStoreList = await this.$api.post("/store/member/get/store");
      // let bindSupplierList = await this.$api.post(
      //   "/member-relation/member/three/year/supplier/supplier-list",
      //   {
      //     member_ids: bindStoreList.token
      //       ? []
      //       : bindStoreList.map((item) => {
      //           return item.member_id;
      //         }),
      //   }
      // );
      let bindSupplierList = await this.$api.post(
        "/member-relation/member/three/year/supplier/supplier-list"
      );
      this.currentMemberId = bindSupplierList.list[0].member_id;
      this.getShopInfo();
    },
    async getShopInfo() {

      this.shopInfo = await this.$api.post(
        "/member-relation/member/three/year/supplier/supplier-name",
        { "member-id": this.currentMemberId }
      );
      if(this.shopInfo){
        await this.getInfo();
      }

      this.orderInfo = await this.$api.post(
        "/onorder/member/order/statistics/by/supplier/number",
        { member_id: this.shopInfo.member_id }
      );
      this.loading = false;
      if (this.shopInfo.is_supplier == 0) {
        return;
      }
      if(!this.show){
        if (sessionStorage.getItem("showPopup")) {
          this.showPopup = false;
        } else {
          this.showPopup = true;
          sessionStorage.setItem("showPopup", "not");
        }
      if (
        this.shopInfo.is_resign == 1 &&
        !this.$route.query.isRefresh &&
        this.showPopup && !this.show
      ) {
        //补签中 存在以下4种状态  补签完成不需要弹框(不做处理即可，此处只处理需要弹框的情况)
        //!resign_status未提交信息//resign_status=2&&is_resign == 0补签完成(再次补签会把is_resign置为1)//resign_status=3补签合同待签署//resign_status=0合同待审核，1平台待审核，-1合同已驳回补签合同审核状态
        if (
          (!this.shopInfo.resign_status || this.shopInfo.resign_status == 2) &&
          this.shopInfo.resign_status != 0
        ) {
          //未提交信息
          this.$dialog
            .confirm({
              message: this.shopInfo.pop_content,
              confirmButtonText: "去签署",
              confirmButtonColor: "#FC740C",
              cancelButtonText: "放弃",
              cancelButtonColor: "#999",
            })
            .then(() => {
              // on confirm
              this.$router.push({
                path: "/purchaseSupplier/selectIndentity",
                query: {
                  supplier_id: this.shopInfo.id,
                  from: "index",
                  resign: 1,
                },
              });
            })
            .catch(() => {
              // on cancel
            });
        } else if (this.shopInfo.resign_status == 3) {
          //补签合同待签署
          this.$dialog
            .confirm({
              message: this.shopInfo.pop_content,
              confirmButtonText: "去签署",
              confirmButtonColor: "#FC740C",
              cancelButtonText: "放弃",
              cancelButtonColor: "#999",
            })
            .then(() => {
              // on confirm
              this.toSign();
            });
          // .catch(() => {
          //   // on cancel
          // });
        } else {
          //补签合同审核状态
          this.$dialog
            .confirm({
              message: this.shopInfo.pop_content,
              confirmButtonText: "去签署",
              confirmButtonColor: "#FC740C",
              cancelButtonText: "放弃",
              cancelButtonColor: "#999",
            })
            .then(() => {
              // on confirm
              this.contractStatus();
            });
          // .catch(() => {
          //   // on cancel
          // });
        }
      }
      }
    },
    goBack() {
      this.params("", "", "goBack");
    },
    seeMSG() {
      this.params("", "", "seeMSG");
    },
    openMiniProgram() {
      if (this.shopInfo.store_status == -2) {
        this.$toast("您的商户身份不存在，暂时不能使用添加员工功能!");
        return;
      }
      if (this.shopInfo.store_status == -1) {
        this.$toast("您的商户身份已封号，暂时不能使用添加员工功能!");
        return;
      }
      this.params(
        JSON.stringify({ minitype: "store" }),
        JSON.stringify({ minitype: "store" }),
        "openMiniProgram"
      );
    },
    switchAccount() {
      this.$router.push({
        path: "/purchaseSupplier/accountManage",
        query: {
          member_id: this.currentMemberId,
        },
      });
    },
    seeOrder() {
      // this.$router.push("/purchaseSupplier/order");
      this.$router.push({
        path: "/purchaseSupplier/order",
        query: {
          from: "h5",
          // store_id: this.shopInfo.store_id,
          is_supplier: this.shopInfo.is_supplier,
          member_id: this.shopInfo.member_id,
        },
      });
    },
    seeAfterOrder() {
      // this.$router.push("/purchaseSupplier/afterOrder");
      this.$router.push({
        path: "/purchaseSupplier/afterOrder",
        query: {
          // store_id: this.shopInfo.store_id,
          is_supplier: this.shopInfo.is_supplier,
          member_id: this.shopInfo.member_id,
        },
      });
    },
    stockManage() {
      this.$router.push("/purchaseSupplier/stock");
    },
    toSign() {
      let parm = {
        url: this.shopInfo.base_file_url,
        is_resign: 1,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "toSign");
    },
    contractStatus() {
      let parm = {
        resign_status: this.shopInfo.resign_status,
        resign_remark: this.shopInfo.resign_remark,
      };
      this.params(JSON.stringify(parm), JSON.stringify(parm), "contractStatus");
    },
    async toWithdraw() {
      await this.pending;
      this.$router.push({
        path: "/purchaseSupplier/withdraw",
        query: {
          id: this.shopInfo.id,
          supplier_number: this.shopInfo.supplier_num,
        },
      });
    },
    async seeContract() {
      await this.pending;
      this.params(
        this.shopInfo.supplier_contract_id,
        this.shopInfo.supplier_contract_id,
        "seeContract"
      );
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.purchase_index {
  height: 100%;
  box-sizing: border-box;
  background: #2e364f;

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

  .purchase_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 3;
    height: 8.8rem;
    padding: 5.4rem 1.2rem 0 2rem;
    box-sizing: border-box;
    background: #2e364f;

    img {
      width: 2.4rem;
    }

    .account_msg {
      float: right;
      font-size: 1.4rem;
      line-height: 2rem;
      color: #fff;

      img {
        width: 1.8rem;
        margin-right: 0.6rem;
        vertical-align: middle;
      }

      .num {
        height: 1.5rem;
        line-height: 1.5rem;
        background: #ff4747;
        border-radius: 0.8rem;
        color: #fff;
        font-size: 1rem;
        padding: 0 0.5rem;
        position: fixed;
        top: 3.9rem;
        right: 1.2rem;
      }
    }
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding-top: 12.3rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .name {
      line-height: 3.3rem;
      color: #fff;
      font-size: 2.4rem;
      font-weight: 700;
      padding: 0 2.4rem;
      margin-bottom: 8.4rem;

      span {
        font-size: 1.4rem;
        font-weight: 100;
        line-height: 2rem;
        display: inline-block;
        vertical-align: middle;
        margin-top: -0.6rem;

        img {
          width: 1.4rem;
          vertical-align: middle;
          margin: 0 0.7rem 0 1.2rem;
        }
      }
    }

    .manage {
      background: #f5f6f7;
      padding: 10.1rem 1.6rem 0;
      min-height: calc(100% - 11.7rem);
      height: auto;
      box-sizing: border-box;
      position: relative;

      .mask {
        width: 7.6rem;
        height: 6rem;
        position: absolute;
        top: -8rem;
        right: 0;
      }

      .goods {
        width: 16.5rem;
        background: #fff;
        height: 14.9rem;
        border-radius: 0.8rem;
        float: left;
        margin-top: -16.1rem;
        padding: 2.3rem 2rem 2rem 2.1rem;
        box-sizing: border-box;

        .number {
          color: #333;
          font-size: 2.4rem;
          line-height: 2.8rem;
          font-weight: 700;
          margin-bottom: 0.8rem;
        }

        .type {
          color: #666;
          font-size: 1.4rem;
          line-height: 2rem;
          margin-bottom: 2.2rem;
        }

        img {
          width: 2.9rem;
          float: right;
        }
      }

      .receive {
        float: right;
      }

      .operationItem {
        height: 7.8rem;
        line-height: 7.8rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0 2.8rem;
        box-sizing: border-box;
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;

        img {
          float: left;
          width: 2.2rem;
          margin: 2.8rem 2rem 0 0;
        }

        .van-icon {
          float: right;
          width: 1.6rem;
          font-weight: 400;
          color: #999;
          margin-top: 3.1rem;
        }

        .msg {
          height: 2.1rem;
          padding: 0.3rem;
          background: #ffcbcb;
          border-radius: 1rem;
          box-sizing: border-box;
          display: inline-block;
          float: right;
          margin-top: 2.8rem;

          .num {
            color: #fff;
            font-size: 1.2rem;
            font-weight: 400;
            height: 1.5rem;
            line-height: 1.5rem;
            background: #ff3c3c;
            border-radius: 0.7rem;
            padding: 0 0.4rem;
            min-width: 1.5rem;
            text-align: center;
            box-sizing: border-box;
            display: inline-block;
            float: left;
          }
        }
      }
    }
  }
}
.van-dialog {
  border-radius: 0.3rem;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
.ship-box{
  display: flex;
  justify-content: space-between;
  .receive{
    margin-left: 1rem;
  }
  &>div{
    flex: 1;
  }
}
.banned-poup{
  padding: 2.4rem 1.5rem;
  min-height: 5rem;
  font-size: 1.4rem;
  color: #333333;
}
/deep/ .banned-box .van-dialog__header{
  font-size: 1.4rem;
  padding-top: 2rem;
}
/deep/ .banned-box .van-button__text{
  font-size: 1.6rem;
}
</style>

